import React, { useEffect, useState } from "react";
import { InfoOutlined, CloseOutlined } from "@ant-design/icons";
const Indicator = ({setShowNotification}) => {
  // const [isScrolled, setIsScrolled] = useState(false);

  // useEffect(() => {
  //   const handleScroll = () => {
  //     console.log(window.scrollY);
  //     setIsScrolled(window.scrollY > 30);
  //   };

  //   window.addEventListener("scroll", handleScroll);
  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, []);

  return (
    <div
      style={{
        position: "sticky",
        top: 0,
        zIndex: 9,
        marginBottom:20,
        marginTop:-22,
        width: "100%",
      }}
      >
      <div
        style={{
          marginLeft:-7,
          marginRight:-7,
          background: "#fff7ed",
          marginTop:-20,
          border: "1px solid #fa931c",
          display:'flex',
          alignItems:'flex-start',
          justifyContent:"space-between"
        }}
      >
        <div
          style={{
            padding: 10,
            paddingRight:15,
            display: "flex",
            alignItems: "center",
            gap: 15,
          }}
        >
          <div
            style={{
              color: "#fa931c",
              border: "2px solid #fa931c",
              borderRadius: "50%",
              display: "block",
              minWidth: 40,
              height: 40,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <InfoOutlined style={{ fontSize: "25px" }} />
          </div>
          <span>
            You may proceed with the documentation if the uploaded details are
            correct to the best of your knowledge. The documents will be sent to
            HR for review.
          </span>
        </div>
        <button onClick={() => setShowNotification(false)} style={{marginRight:10,marginTop:10,outline:'none'}}>
          <CloseOutlined style={{fontSize:15}} />
        </button>
      </div>
    </div>
  );
};

export default Indicator;
